import { createRootRouteWithContext } from '@tanstack/react-router';
import { RouterContext } from '../types';

export const Route = createRootRouteWithContext<RouterContext>()({});
